module.exports = __webpack_public_path__ + "img/maximum.9c753cf3.svg";